function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.7305 0.333374L67.461 19.6667V58.3334L33.7305 77.6667L0 58.3334V19.6667L33.7305 0.333374ZM2.30145 20.9858V57.0142L33.7305 75.0285L65.1595 57.0142V20.9858L33.7305 2.97162L2.30145 20.9858Z",
  fill: "url(#paint0_radial_7089_139060)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.1145 31.2759C39.5497 30.2578 36.7878 29.726 33.9982 29.726C28.1355 29.726 22.6207 32.0438 18.4702 36.2522C14.3378 40.442 12.0418 46.0077 12.0049 51.9239L12 52.7183L12.6856 53.1108C15.9896 55.004 19.7261 56 23.5124 56C23.6165 56 23.7215 55.9992 23.8258 55.9974C27.1263 55.9495 30.3916 55.1507 33.3519 53.6757C32.4184 53.1498 31.5239 52.5579 30.6736 51.9048C25.5139 53.9518 19.6662 53.6997 14.7174 51.1361C15.1987 40.7544 23.6872 32.438 33.9982 32.438C36.8662 32.438 39.6989 33.0768 42.257 34.2907C42.29 33.2856 42.243 32.2783 42.1145 31.2759Z",
  fill: "url(#paint1_radial_7089_139060)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.9916 51.7396C55.9133 44.3843 52.3564 37.6735 46.4269 33.5856C46.4313 34.6619 46.36 35.7376 46.2131 36.8069C50.4265 40.271 52.9948 45.3715 53.276 50.9598C44.1878 55.6753 32.8538 52.3731 27.6911 43.3622C26.2966 40.928 25.4416 38.2068 25.1904 35.4261C24.3132 35.9077 23.4755 36.4618 22.6847 37.0831C23.1017 39.7592 24.0079 42.3578 25.3603 44.718C28.2971 49.8437 33.0188 53.5189 38.6548 55.0656C40.567 55.5902 42.5109 55.8498 44.4447 55.8498C48.2116 55.8498 51.9388 54.8645 55.311 52.9332L56 52.538L55.9916 51.7396Z",
  fill: "url(#paint2_radial_7089_139060)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.7757 14.4015L34.0959 14L33.4161 14.4009C30.0569 16.3804 27.2662 19.2185 25.3453 22.6082C23.6866 25.5355 22.7055 28.8147 22.4754 32.1619C23.3949 31.6115 24.3529 31.1275 25.3434 30.7139C26.1967 25.1962 29.3833 20.2093 34.0946 17.1618C42.7476 22.7643 45.5936 34.3805 40.3958 43.4521C38.9883 45.9089 37.0637 48.0329 34.7836 49.6638C35.635 50.1871 36.5296 50.6408 37.4588 51.0205C39.5664 49.2996 41.3612 47.1916 42.7265 44.8079C48.795 34.2165 45.2284 20.5762 34.7757 14.4015Z",
  fill: "url(#paint3_radial_7089_139060)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.0823 37.5451C32.8428 37.5451 31.8344 38.5613 31.8344 39.8106C31.8344 41.0596 32.8428 42.076 34.0823 42.076C35.3222 42.076 36.3307 41.0596 36.3307 39.8106C36.3307 38.5613 35.3222 37.5451 34.0823 37.5451ZM34.0823 44.788C31.3587 44.788 29.1431 42.5549 29.1431 39.8106C29.1431 37.0659 31.3587 34.8331 34.0823 34.8331C36.8063 34.8331 39.0222 37.0659 39.0222 39.8106C39.0222 42.5549 36.8063 44.788 34.0823 44.788Z",
  fill: "url(#paint4_radial_7089_139060)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_7089_139060",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-28.4997 -79.5022) rotate(55.4) scale(419.129 22920.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_7089_139060",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-28.4997 -79.5022) rotate(55.4) scale(419.129 22920.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_7089_139060",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-28.4997 -79.5022) rotate(55.4) scale(419.129 22920.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_7089_139060",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-28.4997 -79.5022) rotate(55.4) scale(419.129 22920.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_7089_139060",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-28.4997 -79.5022) rotate(55.4) scale(419.129 22920.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})));

function SvgTendermintCore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTendermintCore);
export default __webpack_public_path__ + "static/media/TendermintCore.4945b10c97b7969542a0da7e73ddb9f6.svg";
export { ForwardRef as ReactComponent };